import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=88400fc2&scoped=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&id=88400fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88400fc2",
  null
  
)

export default component.exports